/** disabled 상태 필드의 에러 표시 (오타 셀렉터 `.disalbed_error` 그대로 유지 — 기존 className 계약 보존) */
export const disabledErrorStyles = `
  .disalbed_error {
    .MuiInputBase-root.Mui-disabled {
      & > fieldset {
        border: 1px solid red;
      }
    }
  }
`;

/** flex 유틸리티 클래스 — .flex_div 단독 */
export const flexDivStyles = `
  .flex_div {
    display: flex;
  }
`;

/** flex 유틸리티 클래스 — .flex_div / .center_content 쌍 */
export const flexUtilStyles = `
  ${flexDivStyles}
  .center_content {
    justify-content: center;
  }
`;

/** 파일 업로드 input 숨김 — .image_input */
export const imageInputStyles = `
  .image_input {
    display: none;
  }
`;

/**
 * 좌측 필드 리스트(List) — setting/Account↔DeviceDetail, ParameterInfo↔ProfileInfo 4곳.
 * withActionTakenLabel: `.action_taken_label` 규칙 유무(setting/Account·DeviceDetail만 보유).
 */
export const fieldListStyles = (
  theme: any,
  { withActionTakenLabel = false }: { withActionTakenLabel?: boolean } = {},
) => `
  .MuiListItemButton-root {
    margin-bottom: 1rem;
    max-width: fit-content;
  }
  .MuiListItemButton-root:hover {
    background-color: transparent;
  }
  .MuiTouchRipple-rippleVisible {
    color: #005d83 !important;
  }
  .list_infor {
    display: flex;
  }
  .ag_grid_data {
    margin: 0px 0px 30px 0px;
  }
  .divider {
    width: 100%;
    margin: 0px 0px 30px 0px;
  }
  ${
    withActionTakenLabel
      ? `
  .action_taken_label {
    margin-right: 13px;
  }
  `
      : ''
  }
  .data_category {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }
  .data_category::before {
    content: "● ";
    color: ${theme.colors.primary.main};
  }
  .list_item_label {
    .MuiTypography-root {
      margin: 0rem 0rem 0.5rem -1.1rem;
      font-size: 1.25rem;
      color: ${theme.colors.primary.main};
    }
  }
  .collapse_icon {
    margin: 0.175rem 0rem 0rem 0.5rem;
    font-size: 1.5rem;
  }
`;

/** 이미지 그리드 아이템 아이콘 배지 — location/InspectionDetail/MaintenanceDetail 3곳 바이트 동일 */
export const fieldImageItemStyles = (theme: any) => `
  cursor: pointer;
  .icon_box {
    background: ${theme.palette.background.default};
    border-radius: 5px;
    bottom: 0;
    right: 0;
    position: absolute;
    margin: 0px 5px 6px 0px;
  }
`;

/**
 * 이미지 행 라인 래퍼(라벨 + 이미지 리스트) — location/InspectionDetail/MaintenanceDetail 3곳.
 * mobileBreakpoint: 모바일 전환 기준 실측값(location 599px, InspectionDetail/MaintenanceDetail 899px) — 인자로 보존.
 */
export const fieldImageLineWrapperStyles = (mobileBreakpoint: string = '899px') => `
  margin: 2rem 0rem 1.1rem 0rem;
  @media (max-width: ${mobileBreakpoint}) {
    margin: 0rem 0rem 2rem 0rem;
  }
  align-content: center;
  .label {
      font-weight : bold;
    }
  .image_list {
    margin-left: -0.6rem;
    margin-bottom: 0.5rem;
  }
`;

/** 이미지 목록 삭제 버튼 — location/InspectionDetail/InspectionList 3곳 바이트 동일 */
export const itemDeleteButtonStyles = (theme: any) => `
  width: 3rem;
  border-radius: 1rem;
  background: ${theme.palette.primary.main};
  color: #ffffff;
  height: 53.13px;
`;

/** 우측 상단 언어 전환 버튼 위치 (support/account/exception/setting/Admin/Company/Preference 등 바이트 동일 클론) */
export const languageSwitcherWrapperStyles = `
  .MuiIconButton-root{
    float : right;
    margin : 5px;
  }
  padding : 5px;
`;

/** 중앙 정렬 로딩 래퍼 (support/account/setting/Admin/Company/Preference 등 바이트 동일 클론) */
export const loadingWrapperStyles = `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

/** 필수 표시(*) — MainWrapper형: bold, top:1px, margin-left:0.5rem */
export const requiredMarkStyles = `
  .required_mark {
    margin-left: 0.5rem;
    position: relative;
    top: 1px;
    color: #da3636;
    font-weight: bold;
  }
`;

/** 필수 항목 에러 텍스트 — MainWrapper형 .required_text (8개 파일 바이트 동일) */
export const requiredTextStyles = `
  .required_text {
    margin-top: -0.1rem;
    position: relative;
    color: #da3636;
    font-weight: bold;
  }
`;

/** 필수 표시(*)/에러 텍스트 — .title_required_mark(margin-left:0.35rem)/.title_required_text 세트. ScheduleList/mes/setting-Admin/DeviceDetail MainWrapper 4곳 바이트 동일(들여쓰기만 차이) */
export const titleRequiredStyles = `
  .title_required_mark {
    margin-left: 0.35rem;
    position: relative;
    top: 1px;
    color: #da3636;
    font-weight: bold;
  }

  .title_required_text {
    margin-top: -0.1rem;
    position: relative;
    color: #da3636;
    font-weight: bold;
  }
`;

/** 필수 표시(*) — FormLine/inline형: bold 없음, top:3px, margin-left:3px */
export const requiredMarkInlineStyles = `
  .required_mark {
    position: relative;
    top: 3px;
    margin-left: 3px;
    color: #da3636;
  }
`;

/** 제출 버튼 영역 — 단순형 (margin-top만) */
export const submitButtonSimpleStyles = ({ marginTop = '27px' }: { marginTop?: string } = {}) => `
  .submit_button {
    margin-top: ${marginTop};
  }
`;

/**
 * 제출 버튼 영역 — margin-top/bottom + 모바일 breakpoint + (선택) crimson .delete 서브셀렉터
 * 파일별 실측값을 인자로 그대로 전달해 렌더 결과 보존
 */
export const submitButtonStyles = ({
  marginTop = '23px',
  marginBottom = '5px',
  mobileMarginTop = '0px',
  withDelete = true,
}: {
  marginTop?: string;
  marginBottom?: string;
  mobileMarginTop?: string;
  withDelete?: boolean;
} = {}) => `
  .submit_button {
    margin-top : ${marginTop};
    margin-bottom : ${marginBottom};
    @media (max-width: 1279px) {
      margin-top : ${mobileMarginTop};
    }
    ${
      withDelete
        ? `
    .delete {
      background-color: crimson;
      &:hover {
        background-color: #a10000;
      }
    }`
        : ''
    }
  }
`;

/**
 * 국가코드 선택 + 전화번호 입력 필드 레이아웃 (PhoneNumberField 9파일 클론) — 파일별 실측값을 인자로 그대로 전달해 렌더 결과 보존
 * buttonMarginTop: .MuiButtonBase-root margin-top (없으면 해당 블록 생략), buttonMobileBreakpoint: 지정 시에만 모바일 미디어쿼리 추가(support/account는 미보유), buttonMobileMarginTop/buttonMobileMarginBottom: 모바일 전환값,
 * withInputPaddingLeft: .MuiInputBase-input padding-left:60px 블록 유무(CreateUserModal은 미보유), inputBreakpoint: 위 블록의 모바일 전환 기준,
 * withInputPhoneNumberHeight: .input_phone_number height:47.5px 추가 여부
 */
export const phoneNumberFieldStyles = ({
  buttonMarginTop,
  buttonMobileBreakpoint,
  buttonMobileMarginTop = '0',
  buttonMobileMarginBottom,
  withInputPaddingLeft = true,
  inputBreakpoint = '899px',
  withInputPhoneNumberHeight = false,
}: {
  buttonMarginTop?: string;
  buttonMobileBreakpoint?: string;
  buttonMobileMarginTop?: string;
  buttonMobileMarginBottom?: string;
  withInputPaddingLeft?: boolean;
  inputBreakpoint?: string;
  withInputPhoneNumberHeight?: boolean;
} = {}) => `
  display: flex;
  align-items: center;
  width: 100%;

  ${
    buttonMarginTop
      ? `
  .MuiButtonBase-root {
    margin-top : ${buttonMarginTop};
    ${
      buttonMobileBreakpoint
        ? `
    @media (max-width: ${buttonMobileBreakpoint}) {
      margin-top : ${buttonMobileMarginTop};
      ${buttonMobileMarginBottom ? `margin-bottom: ${buttonMobileMarginBottom};` : ''}
    }
    `
        : ''
    }
  }
  `
      : ''
  }

  .MuiInputBase-root {
    padding-left : 0;

    .MuiInputAdornment-root {
      position : absolute;
      left : 15px;
    }

    ${
      withInputPaddingLeft
        ? `
    .MuiInputBase-input{
      padding-left : 60px;

      @media (max-width: ${inputBreakpoint}) {
        padding-left : 50px;
      }
    }
    `
        : ''
    }
  }

  ${
    withInputPhoneNumberHeight
      ? `
  .input_phone_number {
    height: 47.5px;
  }
  `
      : ''
  }
`;

/**
 * 필드 옆 X(clear) 버튼 — errorState 시 red + 점멸(errorBlinkKeyframes 호출부에서 합성), 평시 primary.main — 파일별 실측 좌표 보존
 * marginLeft/marginTop: 파일별 실측 좌표. hoverBackground: alpha(theme.palette.primary.main, 0.45) 등 호출부에서 계산한 값 전달.
 * 호출부에서 `${errorState && errorBlinkKeyframes}`를 별도로 이어붙일 것(기존 계약 유지).
 */
export const clearButtonStyles = ({
  theme,
  errorState,
  marginLeft,
  marginTop,
  hoverBackground,
}: {
  theme: any;
  errorState?: boolean;
  marginLeft: string;
  marginTop: string;
  hoverBackground: string;
}) => `
  width: 1rem;
  height: 1.15rem;
  position: absolute;
  margin-left: ${marginLeft};
  margin-top: ${marginTop} !important;
  color: #ffffff;
  background: ${errorState ? 'red' : theme.palette.primary.main};
  &:hover {
    background: ${hoverBackground};
  },
`;

/**
 * .icon_content 내부 InputAdornment 버튼 padding/breakpoint — 파일별 실측값을 인자로 그대로 전달해 렌더 결과 보존
 * buttonPadding: 버튼 padding (11px | 14px), withOpacity: InputAdornment opacity:1 유무,
 * breakpoint: 모바일 전환 기준 (599px | 899px), mobileFontSize: 모바일 폰트 크기 (0.5rem | 0.7rem)
 */
export const iconContentStyles = ({
  buttonPadding = '11px',
  withOpacity = false,
  breakpoint = '899px',
  mobileFontSize = '0.5rem',
}: {
  buttonPadding?: string;
  withOpacity?: boolean;
  breakpoint?: string;
  mobileFontSize?: string;
} = {}) => `
  .icon_content {
    .MuiInputBase-root{
      padding : 0;

      .MuiInputAdornment-root  {
        padding : 0;
        ${withOpacity ? 'opacity: 1;' : ''}
        .MuiButton-root{
          padding : ${buttonPadding};
          border : none;

          @media (max-width: ${breakpoint}) {
            padding : 16px 8px;
            font-size: ${mobileFontSize};
          }
        }
      }
    }
  }
`;

/**
 * 인증(로그인/회원가입/비밀번호찾기) 폼 카드 골격 —
 * account::AccountAuthFormWrapper ↔ support::SupportAuthFormWrapper 2곳 바이트 동일
 * (submitButtonSimpleStyles/iconContentStyles 참조).
 */
export const authFormWrapperStyles = () => `
  margin-top: 27px;
  padding: 36px;
  white-space: pre-line;
  .title {
    margin-bottom: 9px;
    font-size: 1.9rem;
    text-align: center;
    @media (max-width: 899px) {
      font-size: 1.5rem;
    }
  }

  .sub_title {
    margin-bottom: 27px;
    font-size: 1rem;
    text-align: center;

    @media (max-width: 899px) {
      font-size: 0.8rem;
    }
  }

  .find_button {
    margin-left: 4.5px;
  }

  ${submitButtonSimpleStyles()}

  .form_content {
    min-height: 250px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .link_button {
    width: 100%;

    .MuiButtonBase-root{

      margin-top : 45px;
      width: 100%;
    }
  }

  .text_content {

    font-size: 0.9rem;

    @media (max-width: 899px) {
      font-size: 0.7rem;
    }

    .MuiFormHelperText-root {
      font-size: 0.8rem;

      @media (max-width: 899px) {
        font-size: 0.7rem;
      }
    }

    .MuiInputBase-input {
      font-size: 0.8rem;

      @media (max-width: 899px) {
        font-size: 0.7rem;
      }
    }
  }

  ${iconContentStyles({ buttonPadding: '14px' })}

  .main_content {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    .MuiTypography-root {
      font-size: 1.5rem;
      @media (max-width: 899px) {
        font-size: 0.9rem;
      }
    }
  }
`;

/**
 * 인증 폼 카드 골격 변형 — setting/Admin::SettingAdminAuthFormWrapper ↔
 * setting/components::AuthFormWrapper 2곳 바이트 동일. authFormWrapperStyles와 달리
 * .form_content에 display:flex가 추가되고 iconContentStyles 호출 없이 .main_content로 끝난다.
 */
export const authFormWrapperWithMainContentStyles = () => `
  margin-top: 27px;
  padding: 36px;
  white-space: pre-line;
  .title {
    margin-bottom: 9px;
    font-size: 1.9rem;
    text-align: center;
    @media (max-width: 899px) {
      font-size: 1.5rem;
    }
  }

  .sub_title {
    margin-bottom: 27px;
    font-size: 1rem;
    text-align: center;

    @media (max-width: 899px) {
      font-size: 0.8rem;
    }
  }

  .find_button {
    margin-left: 4.5px;
  }

  ${submitButtonSimpleStyles()}

  .form_content {
    min-height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .link_button {
    width: 100%;

    .MuiButtonBase-root{
      margin-top : 45px;
      width: 100%;
    }
  }

  .text_content {
    font-size: 0.9rem;

    @media (max-width: 899px) {
      font-size: 0.7rem;
    }

    .MuiFormHelperText-root {
      font-size: 0.8rem;

      @media (max-width: 899px) {
        font-size: 0.7rem;
      }
    }

    .MuiInputBase-input {
      font-size: 0.8rem;

      @media (max-width: 899px) {
        font-size: 0.7rem;
      }
    }
  }

  .main_content {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    .MuiTypography-root {
      font-size: 1.5rem;
      @media (max-width: 899px) {
        font-size: 0.9rem;
      }
    }
  }
`;

/** 항목 추가 pill 버튼(nested row/item add) — ProfileInfo↔mes/Item 바이트 동일 */
export const nestedRowAddButtonStyles = (theme: any) => `
  margin-top: 18px;
  margin-bottom: -2px;
  height: 33px;
  width: max-content;
  border-radius: 4px;
  color: ${theme.palette.background.paper};
`;

/** 고급 설정 토글 텍스트(밑줄 hover) — InspectionDetail↔MaintenanceDetail 바이트 동일 */
export const advancedToggleTextStyles = `
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
`;
